import { SHOW_BOOKING_DETAILS } from "./types";

const showBookingDetails = () => ({
  type: SHOW_BOOKING_DETAILS,
});

export default showBookingDetails;
